export default "__VITE_ASSET__580468e7__"